/**
 * Intro block explaining what this module does. Go into as much detail as needed,
 * the dev reading this should be able to understand what this module does
 * without having to read any code. List any plugins used.
 */
import $ from 'jquery';

// Cached elements
const $area = $('.js-county');
const $areaActive = $('.js-county-active');
const $areaSelect = $('.js-area-select');

let $target;

if ($('.js-area-map').is('#installers-map')) {
	$target = '/find-an-installer?county=';
} else if ($('.js-area-map').is('#stockists-map')) {
	$target = '/installers/support/stockist-locator?county=';
}

// Module events
export default function init() {
	bindEvents();
}

// User interactions go here
function bindEvents() {
	toolTips();
	if (!$areaActive.length) return;
	activeCounty();
	goToCounty();
	mobileSelect();
}

function goToCounty() {
	$areaActive.click(function(event) {
		$areaActive.removeClass('is-active');

		var target = $(this).data('county');
		target = $target + target + '#results';

		$(this).addClass('is-active');

		//window.history.pushState('obj', 'newtitle', target);
		window.location.href = target;

		event.preventDefault();

	});
}

function activeCounty() {
	var currentCounty = getUrlParameter('county');

	$areaActive.each(function() {
		if ($(this).data('county') === currentCounty) {
			$(this).addClass('is-active');
		}
	});

}

function getUrlParameter(sParam) {
    var sPageURL = decodeURIComponent(window.location.search.substring(1)),
        sURLVariables = sPageURL.split('&'),
        sParameterName,
        i;

    for (i = 0; i < sURLVariables.length; i++) {
        sParameterName = sURLVariables[i].split('=');

        if (sParameterName[0] === sParam) {
            return sParameterName[1] === undefined ? true : sParameterName[1];
        }
    }
}

function toolTips() {
	$area.tooltipster({
    	contentCloning: true
	});
}

function mobileSelect() {
	// bind change event to select
	$areaSelect.on('change', function (event) {
		var target = $(this).val();
		target = $target + target + '#results';
			if (target) { // require a URL
			window.location = target; // redirect
		}
		event.preventDefault();
	});
};